module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-miner w100"
  }, [_c('table', {
    staticClass: "table is-fullwidth table-reward-stats"
  }, [_c('tbody', [_c('tr', [_vm._m(0), _c('td', {
    staticClass: "amount"
  }, [_c('span', {
    attrs: {
      "id": "pending_mining_balance"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _c('span', [_vm._v(_vm._s(_vm.stats.balance_mining))])])])]), _c('tr', [_vm._m(1), _c('td', {
    staticClass: "amount"
  }, [_c('span', {
    attrs: {
      "id": "pending_referral_balance"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.stats.balance_referral))])])])]), _c('tr', [_vm._m(2), _c('td', {
    staticClass: "amount"
  }, [_c('span', {
    staticClass: "pending_balance"
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.stats.balance))])])])]), _c('tr', [_c('td', [_c('div', {
    staticClass: "w400"
  }, [_vm._v("Past 24 hours rewards")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("Total rewards obtained over the past 24 hours (updates hourly)")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("From " + _vm._s(_vm.stats.rewarded_timestamp.past_24h[0]) + " to " + _vm._s(_vm.stats.rewarded_timestamp.past_24h[1]))])]), _c('td', {
    staticClass: "amount"
  }, [_c('span', {
    attrs: {
      "id": "total_24h"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.stats.rewarded.past_24h))])])])]), _c('tr', [_c('td', [_c('div', {
    staticClass: "w400"
  }, [_vm._v("Past 7 days rewards")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("Total rewards obtained over the past 7 days (updates hourly)")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("From " + _vm._s(_vm.stats.rewarded_timestamp.past_7d[0]) + " to " + _vm._s(_vm.stats.rewarded_timestamp.past_7d[1]))])]), _c('td', {
    staticClass: "amount"
  }, [_c('span', {
    attrs: {
      "id": "total_7d"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.stats.rewarded.past_7d))])])])]), _c('tr', [_c('td', [_c('div', {
    staticClass: "w400"
  }, [_vm._v("Past 30 days rewards")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("Total rewards obtained over the past 30 days (updates hourly)")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("From " + _vm._s(_vm.stats.rewarded_timestamp.past_30d[0]) + " to " + _vm._s(_vm.stats.rewarded_timestamp.past_30d[1]))])]), _c('td', {
    staticClass: "amount"
  }, [_c('span', {
    attrs: {
      "id": "total_30d"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.stats.rewarded.past_30d))])])])]), _c('tr', [_vm._m(3), _c('td', {
    staticClass: "amount"
  }, [_c('span', {
    attrs: {
      "id": "total_paid"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.stats.paid))])])])]), _c('tr', [_vm._m(4), _c('td', {
    staticClass: "amount"
  }, [_c('span', {
    attrs: {
      "id": "last_payment_date"
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.stats.last_payment_date))])])])]), _c('tr', [_vm._m(5), _c('td', {
    staticClass: "amount"
  }, [_c('span', {
    staticClass: "threshold_amount"
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.paymentThreshold))])])])]), _c('tr', [_vm._m(6), _c('td', {
    staticClass: "amount"
  }, [(_vm.miningFee == '0.75') ? _c('span', {
    staticClass: "current-fee"
  }, [_vm._v("0.75%")]) : _c('span', {
    staticClass: "current-fee"
  }, [_vm._v("1%")]), (_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "w400"
  }, [_vm._v("Mining balance")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("Balance obtained by mining via GPU / CPU / ASIC")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "w400"
  }, [_vm._v("Referral balance")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("Balance obtained by sharing your referral code")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "w400"
  }, [_vm._v("Total balance")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("Sum of mining + referral balance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "w400"
  }, [_vm._v("Total Paid")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("Total paid to your wallet")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "w400"
  }, [_vm._v("Last payment date")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("Last payment sent to your wallet")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "w400"
  }, [_vm._v("Payment threshold")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("A payout can be processed once you reach the payment threshold")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('div', {
    staticClass: "w400"
  }, [_vm._v("Current mining fee")]), _c('div', {
    staticClass: "w100 s12"
  }, [_vm._v("Fees can be reduced to 0.75% when a referral code is used.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7de4fbe2","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_tab_stats.vue
// module id = 386
// module chunks = 1